export interface MenuItemType {
    /** label of the menu item */
    label: string;
    /** unique slug of the menu item */
    slug: string;
    /** optional icon which is shown before the label */
    icon?: string;
    /** optional nested menu items */
    items?: MenuItemType[];
    /** link url if used as link */
    href?: string;
    /** link target if used as link */
    target?: string;
    /** download filename if used as link */
    download?: string;
    /** controls if the menu item is currently selected */
    selected?: boolean;
    /** controls if a separator line is rendered before the menu item */
    separator?: boolean;
    /** controls if the menu item should act as a toggle */
    toggle?: boolean;
    /** optional badge for the menu item */
    badge?: number | string;
}
